import React from "react";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import CartItem from "./cartItem";
import useCartStore from "../../stores/useCartStore";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../../Utilities/priceUtils";

function NewCart({ currency, orderContext }) {
  const intl = useIntl();
  const navigate = useNavigate();
  const result = useCartStore((state) => state.result);
  const lastAddedItem = useCartStore((state) => state.lastAddedItem);
  const deleteFromCart = useCartStore((state) => state.deleteFromCart);

  const handleDeleteFromCart = (cartItem) => {
    deleteFromCart(cartItem.fortnoxNumber);
  };

  const totalAmount = () => {
    return result.reduce((acum, item) => {
      acum += item.priceStudent * item.addedStudents.length;
      return acum;
    }, 0);
  };
  const handleCheckIfIsLastAdded = (cartItem) => {
    if (lastAddedItem.isPlusPackage) {
      if (
        lastAddedItem.studentLicense.fortnoxNumber ===
          cartItem.fortnoxNumber ||
        lastAddedItem.plusPackage.fortnoxNumber === cartItem.fortnoxNumber
      )
        return true;
    } else {
      if (lastAddedItem.fortnoxNumber === cartItem.fortnoxNumber) {
        return true;
      }
    }
    return false;
  };
  const buildCartList = () => {
    return result.map((cartItem, i) => {
      return (
        <CartItem
          key={i}
          cartItem={cartItem}
          readonly={false}
          handleDeleteFromCart={() => handleDeleteFromCart(cartItem)}
          isLatestAdded={handleCheckIfIsLastAdded(cartItem)}
        />
      );
    });
  };

  const buildCart = () => {
    return (
      <div style={{ margin: "10px" }}>
        <Card>
          <CardHeader>
            <h5 className="mb-0">
              <FormattedMessage id="MyCart" />
            </h5>
          </CardHeader>

          <CardBody>{buildCartList()}</CardBody>
        </Card>
      </div>
    );
  };

  const buildCartTotal = () => {
    return (
      <div style={{ margin: "10px" }}>
        <Card>
          <Row>
            <Col>
              <div
                className="float-end pt-1 "
                style={{ marginRight: "15px", paddingBottom: ".3rem" }}
              >
                {" "}
                <h5 style={{ marginTop: "8px" }}>
                  <FormattedMessage id="TotalCost" />:{" "}
                  {formatPrice(totalAmount(), currency, intl)}
                </h5>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {result.length > 0 ? (
                <div
                  className="float-end"
                  style={{ paddingBottom: "1.05rem", paddingRight: ".9rem" }}
                >
                  <Button
                    disabled={
                      !result.some((item) => item.addedStudents.length > 0)
                    }
                    outline
                    color="primary"
                    onClick={() =>
                      navigate(
                        orderContext
                          ? "/superuser/shop/confirmedorder"
                          : "/teacher/shop/confirmedorder",
                        { state: orderContext ? { orderContext } : undefined },
                      )
                    }
                  >
                    <FormattedMessage id="GoToCheckout" />
                  </Button>
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </Card>
      </div>
    );
  };

  return (
    <>
      {result.length !== 0 ? (
        <aside className="cart">
          {buildCart()}
          {buildCartTotal()}
        </aside>
      ) : (
        <aside className="empty-cart">
          <FormattedMessage id="YourCartIsEmpty" />
        </aside>
      )}
    </>
  );
}

export default NewCart;
